module.exports = __webpack_public_path__ + "static/media/Abfalleimer.3042a592.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Abfalleimer.png
// module id = 141
// module chunks = 0